import { api } from "./api";

export const appConfigList = async () => {
  return await api.get(`/app/configs`);
};

export const appConfig = async (addUrl = ``) => {
  return await api.get(`/app/config?${addUrl}`);
};

export const appConfigUpdate = async (data) => {
  return await api.post("/app/config/update", data);
};
export const getAppConfigList = () => {
  return JSON.parse(localStorage.getItem("app_configs") ?? "[]");
};
